import "./index.css";
import "./WebComponentWrapper";
import reportWebVitals from "./reportWebVitals";

reportWebVitals();
